/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProjectsInputs */

const cs_nav_projects = /** @type {(inputs: Nav_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekty`)
};

const en_nav_projects = /** @type {(inputs: Nav_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projects`)
};

/**
* | output |
* | --- |
* | "Projects" |
*
* @param {Nav_ProjectsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_projects = /** @type {((inputs?: Nav_ProjectsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProjectsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_projects(inputs)
	return cs_nav_projects(inputs)
});